class SportwristxHeroMedia extends HTMLElement {
  connectedCallback() {
    const hero = this.closest('.swx-video-hero');
    this.videos = [...this.querySelectorAll('video')];
    if (!this.videos.length) {
      requestAnimationFrame(() => hero?.classList.add('is-ready'));
      return;
    }
    this.mobileQuery = window.matchMedia('(max-width: 749px)');
    this.onViewportChange = () => this.syncVideos();
    this.onVideoFailure = (event) => this.failVideo(event.currentTarget);
    this.videos.forEach((video) => {
      video.addEventListener('error', this.onVideoFailure);
      video.addEventListener('stalled', this.onVideoFailure);
      video.addEventListener('abort', this.onVideoFailure);
    });
    this.mobileQuery.addEventListener('change', this.onViewportChange);
    this.syncVideos();
    requestAnimationFrame(() => hero?.classList.add('is-ready'));
  }

  disconnectedCallback() {
    this.mobileQuery?.removeEventListener('change', this.onViewportChange);
    this.videos?.forEach((video) => {
      video.removeEventListener('error', this.onVideoFailure);
      video.removeEventListener('stalled', this.onVideoFailure);
      video.removeEventListener('abort', this.onVideoFailure);
    });
  }

  activeVideo() {
    if (this.mobileQuery?.matches) {
      return this.querySelector('.swx-video-hero__video--mobile') || this.querySelector('.swx-video-hero__video--desktop');
    }
    return this.querySelector('.swx-video-hero__video--desktop') || this.querySelector('.swx-video-hero__video--mobile');
  }

  syncVideos() {
    const active = this.activeVideo();
    this.videos.forEach((video) => {
      const isActive = video === active;
      if (!isActive) {
        video.pause();
        video.removeAttribute('autoplay');
        video.setAttribute('preload', 'none');
        return;
      }

      video.muted = true;
      video.playsInline = true;
      video.setAttribute('autoplay', '');
      video.setAttribute('preload', 'auto');
      this.toggleAttribute('data-video-failed', video.classList.contains('is-failed'));
      if (video.classList.contains('is-failed')) return;

      try {
        const playPromise = video.play();
        playPromise?.catch(() => this.failVideo(video));
      } catch {
        this.failVideo(video);
      }
    });
  }

  failVideo(video) {
    video?.classList.add('is-failed');
    if (video === this.activeVideo()) this.dataset.videoFailed = video.dataset.heroViewport || 'active';
  }
}

if (!customElements.get('sportwristx-hero-media')) {
  customElements.define('sportwristx-hero-media', SportwristxHeroMedia);
}
